import { render, staticRenderFns } from "./anfrage.vue?vue&type=template&id=6d6d8145&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./anfrage.vue?vue&type=script&lang=js"
export * from "./anfrage.vue?vue&type=script&lang=js"
import style0 from "./anfrage.vue?vue&type=style&index=0&id=6d6d8145&prod&lang=css"
import style1 from "./anfrage.vue?vue&type=style&index=1&id=6d6d8145&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6d8145",
  null
  
)

export default component.exports